import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import Compare from "../../../../V2/Cards/Packages/Compare"

import { getUrlFromStoryblokLink } from "@utils/storyblok"

const StoryblokCompareCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.CompareCard>) => {
  return (
    <Compare
      backgroundColor={blok.backgroundColor}
      accentColor={blok.accentColor}
      heading={blok.title}
      description={blok.description}
      priceValue={blok.priceValue}
      priceSuperscriptText={blok.priceSuperscript}
      priceAdornmentText={blok.priceAdornment}
      priceStrikeSuperscriptText={blok.priceStrikeSuperscript}
      priceSubscriptText={blok.priceSubscript}
      priceDisclaimerText={blok.priceDisclaimer}
      adornmentTextPosition={blok.adornmentTextPosition}
      pillButtonText={blok.primaryCtaText}
      pillButtonUrl={getUrlFromStoryblokLink(blok.primaryCtaLink)}
      textButtonText={blok.secondaryCtaText}
      textButtonUrl={
        blok.secondaryCtaLink && getUrlFromStoryblokLink(blok.secondaryCtaLink)
      }
      badgeText={blok.badge}
      buyerRecievesList={blok.buyerReceivesList}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokCompareCard
